/**
 * Block /rsi-gempages-overwrite ONLY until Releasit transforms the CTA.
 * Once ready, never intercept clicks again — reopen must work every time.
 */
(function () {
  'use strict';

  if (window.__rsiBtnGuardV2) return;
  window.__rsiBtnGuardV2 = true;

  var PLACEHOLDER_HREF = '/rsi-gempages-overwrite';
  var READY_CLASS = '_rsi-buy-now-button-product';
  var CHECK_INTERVAL = 150;
  var MAX_WAIT_MS = 20000;

  var releasitReady = false;
  var observer = null;
  var intervalId = null;
  var elapsed = 0;
  var pendingReplay = false;

  function isReleasitReady() {
    return !!document.querySelector(
      '.' + READY_CLASS + ', #rsi_buy_now_button, a._rsi-buy-now-button-product'
    );
  }

  function hydrateNow() {
    if (typeof window.__rsiHydrateReleasit === 'function') {
      window.__rsiHydrateReleasit();
    }
    try {
      document.dispatchEvent(new CustomEvent('startasyncloading'));
    } catch (e) { /* ignore */ }
  }

  function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function markReady(shouldReplay) {
    if (releasitReady) {
      if (shouldReplay && pendingReplay) {
        pendingReplay = false;
        setTimeout(replayBuyClick, 60);
      }
      return;
    }
    releasitReady = true;
    cleanup();
    // Remove capture listener — never block again after ready
    document.removeEventListener('click', handleClick, true);

    if (shouldReplay || pendingReplay) {
      pendingReplay = false;
      setTimeout(replayBuyClick, 60);
    }
  }

  function replayBuyClick() {
    var readyBtn =
      document.querySelector('a.' + READY_CLASS) ||
      document.querySelector('.' + READY_CLASS) ||
      document.querySelector('#rsi_buy_now_button');
    if (!readyBtn) return;
    try {
      readyBtn.click();
    } catch (e) { /* ignore */ }
  }

  function handleClick(e) {
    // After ready, listener is removed — this only runs while waiting
    if (releasitReady) return;

    var target = e.target;
    while (target && target.tagName !== 'A' && target.tagName !== 'BUTTON') {
      target = target.parentElement;
    }
    if (!target) return;

    var href = (target.getAttribute('href') || '').trim();
    var isPlaceholder =
      href === PLACEHOLDER_HREF || href.indexOf('rsi-gempages-overwrite') !== -1;

    if (!isPlaceholder) return;

    // Still a raw placeholder — hydrate and wait; block navigation only
    e.preventDefault();
    e.stopPropagation();
    pendingReplay = true;
    hydrateNow();

    if (isReleasitReady()) {
      markReady(true);
      return;
    }

    if (!intervalId) {
      elapsed = 0;
      intervalId = setInterval(function () {
        elapsed += CHECK_INTERVAL;
        if (isReleasitReady()) {
          markReady(true);
          return;
        }
        if (elapsed >= MAX_WAIT_MS) {
          cleanup();
          pendingReplay = false;
          document.removeEventListener('click', handleClick, true);
        }
      }, CHECK_INTERVAL);
    }
  }

  function startGuard() {
    document.addEventListener('click', handleClick, true);

    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (isReleasitReady()) markReady(false);
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'href', 'id'],
      });
    }

    intervalId = setInterval(function () {
      elapsed += CHECK_INTERVAL;
      if (isReleasitReady()) {
        markReady(false);
        return;
      }
      if (elapsed >= MAX_WAIT_MS) {
        cleanup();
        document.removeEventListener('click', handleClick, true);
      }
    }, CHECK_INTERVAL);
  }

  if (isReleasitReady()) {
    releasitReady = true;
    return;
  }

  startGuard();
})();
